import type { UseHttp } from '~/api/interface'

export const fetchNewsHomePageList: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/homePageList', params, { ...option })
}

export const getNewsByExhibitionId: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/getNewsbyExhibitionId/', params, { ...option })
}

export const fetchNewsById: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/get', params, { ...option })
}

export const fetchNewsViewById: UseHttp = (params, option) => {
  return useHttp.post(`/api/newsApi/getNewsView/${params?.id}`, params, { ...option })
}

export const fetchNewsRelatedById: UseHttp = (params, option) => {
  return useHttp.post(`/api/news/get/related/${params?.id}`, params, { ...option })
}

export const fetchNewsCountById: UseHttp = (params, option) => {
  return useHttp.post('/api/newsApi/getAndCount', params, { ...option })
}

export const fetchNewsAttentionById: UseHttp = (params, option) => {
  return useHttp.post(`/api/news/attention/${params?.id}`, params, { ...option })
}
